module.exports = __webpack_public_path__ + "static/media/left-arrow.c59d54d3.svg";